(function () {
  'use strict';
  var root = document.getElementById('yap'), dataEl = document.getElementById('yapData');
  if (!root || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var inr = function (c) { return '₹' + Math.round(c / 100).toLocaleString('en-IN'); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); };

  var track = $('[data-yap-track]'), cnt = $('[data-yap-cnt]'), dots = $$('[data-yap-dots] i');
  if (track && (cnt || dots.length)) {
    var n = track.children.length;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === Math.min(i, dots.length - 1)); });
    }, { passive: true });
  }

  var hasSize = D.sz > 0, multi = D.v.length > 1;
  var sizes = [], seen = {};
  D.v.forEach(function (v) { var s = hasSize ? v.o[D.sz - 1] : v.o[0]; if (!seen[s]) { seen[s] = 1; sizes.push(s); } });
  var other = {};
  $$('[data-yap-opt]').forEach(function (g) {
    var b = g.querySelector('[aria-pressed=true]') || g.querySelector('button');
    other[g.getAttribute('data-yap-opt')] = b.getAttribute('data-val');
  });
  var tiers = (D.tiers || []).slice().sort(function (a, b) { return b[0] - a[0]; });
  var state = { qty: tiers.length ? 2 : 1, sel: [null, null, null] };

  function variantFor(size) {
    return D.v.filter(function (v) {
      if (hasSize && v.o[D.sz - 1] !== size) return false;
      for (var k in other) { if (+k !== D.sz - 1 && v.o[+k] !== other[k]) return false; }
      return true;
    })[0] || null;
  }
  // Shopify applies the single best bundle tier, so mirror that here.
  function total(n) {
    var best = 0;
    tiers.forEach(function (x) { if (n >= x[0]) best = Math.max(best, x[0] * D.unit - x[1]); });
    return n * D.unit - best;
  }
  function saveFor(n) { return D.unit * n - total(n); }

  function setBundles() {
    $$('[data-yap-bun] button').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-n') === state.qty); });
  }
  function renderRows() {
    var box = $('[data-yap-rows]'); if (!box) return;
    var h = '';
    for (var i = 0; i < state.qty; i++) {
      h += '<div class="yap-row" data-i="' + i + '">' + (state.qty > 1 ? '<span>#' + (i + 1) + '</span>' : '') + sizes.map(function (s) {
        var v = variantFor(s), ok = v && v.a;
        return '<button type="button" data-s="' + esc(s) + '" aria-pressed="' + (state.sel[i] === s) + '"' + (ok ? '' : ' disabled') + '>' + esc(s) + '</button>';
      }).join('') + '</div>';
    }
    box.innerHTML = h;
    var sh = $('[data-yap-sh]'); if (sh) sh.textContent = state.qty > 1 ? 'Pick a size for each item' : 'Size';
  }
  function missing() {
    if (!hasSize || !multi) return -1;
    for (var i = 0; i < state.qty; i++) if (!state.sel[i]) return i;
    return -1;
  }
  function msg(t) { var m = $('[data-yap-msg]'); if (m) m.textContent = t || ''; }
  function update() {
    var m = missing(), chosen = state.sel.slice(0, state.qty), sv = saveFor(state.qty), t = total(state.qty);
    var sum = !hasSize || !multi ? (state.qty + (state.qty > 1 ? ' items' : ' item')) : state.qty === 1 ? (chosen[0] ? 'Size ' + chosen[0] : 'Select a size') : state.qty + ' items · Sizes ' + chosen.map(function (x) { return x || '?'; }).join(', ') + (sv > 0 ? ' · You save ' + inr(sv) : '');
    $$('[data-yap-sum],[data-yap-sum2]').forEach(function (e) { e.textContent = sum; });
    $$('[data-yap-add],[data-yap-buy]').forEach(function (b) { b.setAttribute('aria-disabled', m !== -1); });
    $$('[data-yap-buy]').forEach(function (b) { b.textContent = m !== -1 ? 'Select size for item ' + (m + 1) : (b.closest('.yap-bar') ? 'Add & view bag' : 'Add & view bag · ' + inr(t)); });
    if (m === -1) msg('');
    var low = '';
    chosen.forEach(function (s) { if (!s || low) return; var v = variantFor(s); if (v && v.q >= 0 && v.q <= 10) low = 'Selling fast: only ' + v.q + ' left in ' + s; });
    var le = $('[data-yap-low]'); if (le) le.textContent = low;
    updateLook();
  }
  function lines() {
    var map = {}, out = [];
    for (var i = 0; i < state.qty; i++) {
      var v = hasSize ? variantFor(state.sel[i]) : variantFor(null);
      if (!v) return null;
      map[v.id] = (map[v.id] || 0) + 1;
    }
    for (var id in map) out.push({ id: +id, quantity: map[id] });
    return out;
  }
  function need(i) {
    msg('Select size for item ' + (i + 1));
    var row = $$('.yap-row')[i] || $('[data-yap-rows]');
    if (row) {
      row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      row.classList.add('is-need'); setTimeout(function () { row.classList.remove('is-need'); }, 2200);
    }
  }
  function post(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add to bag'); return j; }); });
  }
  function busy(btn, on, txt) { if (on) { btn._t = btn.textContent; btn.textContent = txt; btn.style.pointerEvents = 'none'; } else { btn.textContent = btn._t; btn.style.pointerEvents = ''; } }

  root.addEventListener('click', function (e) {
    var t = e.target;
    var b = t.closest('[data-yap-bun] button');
    if (b) { state.qty = +b.getAttribute('data-n'); setBundles(); renderRows(); update(); return; }
    var s = t.closest('.yap-row button');
    if (s) { var i = +s.parentNode.getAttribute('data-i'); state.sel[i] = s.getAttribute('data-s'); renderRows(); update(); return; }
    var o = t.closest('[data-yap-opt] button');
    if (o) {
      var g = o.parentNode; other[g.getAttribute('data-yap-opt')] = o.getAttribute('data-val');
      $$('button', g).forEach(function (x) { x.setAttribute('aria-pressed', x === o); });
      renderRows(); update(); return;
    }
    if (t.closest('[data-yap-guide]')) { e.preventDefault(); return; }
    if (t.closest('[data-yap-pinok]')) {
      var v = $('[data-yap-pin]').value.trim();
      var span = $('.yap-del span');
      if (/^\d{6}$/.test(v)) span.innerHTML = 'Delivery by <b>' + window.ylApp.eta(5) + '</b> to ' + v + ' · free on prepaid · COD available'; else $('[data-yap-pin]').focus();
      return;
    }
    var add = t.closest('[data-yap-add]'), buy = t.closest('[data-yap-buy]');
    if (add || buy) {
      var mi = missing();
      if (mi !== -1) { need(mi); return; }
      var items = lines(); if (!items) { need(0); return; }
      var btn = add || buy;
      busy(btn, true, 'Adding…');
      window.__yaQuiet = !!add;
      post(items).then(function () {
        busy(btn, false);
        if (add) {
          var old = btn.textContent; btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = old; }, 1800);
        }
        setTimeout(function () { window.__yaQuiet = false; }, 400);
      }).catch(function (err) { busy(btn, false); window.__yaQuiet = false; msg(err.message); });
      return;
    }
    var la = t.closest('[data-yap-lkadd]');
    if (la) {
      var sel = $('[data-yap-lksize]'), one = $('[data-yap-lkone]');
      var lid = sel ? sel.value : (one && one.value);
      if (hasSize && multi && !state.sel[0]) { need(0); return; }
      if (!lid) { sel.focus(); return; }
      var mv = hasSize ? variantFor(state.sel[0]) : variantFor(null);
      busy(la, true, 'Adding…');
      post([{ id: mv.id, quantity: 1 }, { id: +lid, quantity: 1 }]).then(function () { busy(la, false); }).catch(function (err) { busy(la, false); msg(err.message); });
    }
  });
  function updateLook() {
    var lk = $('[data-yap-look]'); if (!lk) return;
    var sel = $('[data-yap-lksize]'), ok = (!hasSize || !multi || state.sel[0]) && (!sel || sel.value);
    $('[data-yap-lkadd]').setAttribute('aria-disabled', !ok);
  }
  var lks = $('[data-yap-lksize]'); if (lks) lks.addEventListener('change', updateLook);

  var cta = $('[data-yap-cta]'), bar = $('.yap-bar');
  if (cta && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { bar.classList.toggle('is-off', en[0].isIntersecting); }, { threshold: 0.3 }).observe(cta);
  } else if (bar) { bar.classList.remove('is-off'); }

  update();
})();